interface ImagePreviewProps {
  props: Record<string, string | number | boolean>
}

export function ImagePreview({ props }: ImagePreviewProps) {
  const src = (props.src as string) || ''
  const alt = (props.alt as string) || 'Image'
  const width = (props.width as string) || '100%'

  return (
    <div className="flex items-center justify-center" style={{ width }}>
      {src ? (
        <img src={src} alt={alt} className="max-w-full h-auto rounded" />
      ) : (
        <div className="w-full h-40 bg-tf-bg-hover rounded flex items-center justify-center">
          <span className="text-tf-text-muted text-sm">Image placeholder</span>
        </div>
      )}
    </div>
  )
}
